export const organizations = {
  title: 'Összes szervezet',
  new: 'Új szervezet',
  createInfo: 'Új szervezet létrehozása a név megadásával. A többi adat későbbi hozzáadásra kerül.',
  deleteModal: {
    title: 'Szervezet törlése',
    message: 'Biztosan törölni szeretné ezt a szervezetet?',
  },
  filters: {
    allOwners: 'Összes tulajdonos',
  },
  roles: {
    owner: 'Tulajdonos',
    administrator: 'Adminisztrátor',
    member: 'Tag',
    members: 'Tagok',
    user: 'Felhasználó',
    invited: 'Meghívott'
  },
  buttons: {
    new: 'Új szervezet',
    cancel: 'Mégse',
    create: 'Létrehozás',
    edit: 'Szerkesztés',
    saveChanges: 'Módosítások mentése',
    cancelChanges: 'Mégse',
    editDetails: 'Szerkesztés',
  },
  fields: {
    name: 'Név',
    regNumber: 'Reg. szám',
    organizationDetails: 'Szervezet adatai',
    cancelChanges: 'Mégse',
    saveChanges: 'Módosítások mentése',
    owner: 'Tulajdonos',
    taxNumber: 'Adószám',
    email: 'Email',
    phone: 'Telefonszám',
    company: {
      title: 'Cég adatai',
      name: 'Cégnév',
      taxNumber: 'Adószám',
      address: 'Cím',
      registrationNumber: 'Cégjegyzékszám',
    },
    address: {
      title: 'Regisztrált cím',
      location: 'Hely',
      address: {
        street: 'Utca',
        city: 'Város',
        postalCode: 'Irányítószám',
        country: 'Ország',
      }
    },
    contact: {
      title: 'Kapcsolattartó',
      contact: {
        name: 'Név',
        email: 'Email',
        phone: 'Telefonszám',
        position: 'Beosztás',
      }
    },
    logo: {
      organizationLogo: 'Szervezet logó',
      noLogo: 'Nincs logó',
      chooseLogoFile: 'Logó fájl kiválasztása',
      recommendedSize: `Ajánlott méret: 400x400px. Max. fájlméret: 2MB.
      Támogatott formátumok: PNG, JPG, JPEG.`,
    },
    users: {
      title: 'Szervezet felhasználói',
      add: 'Felhasználó hozzáadása',
      remove: 'Felhasználó törlése',
      confirmRemove: 'Biztosan el szeretné távolítani ezt a felhasználót a szervezetből?',
      cancelRemove: 'Mégse',
      confirmRemoveTitle: 'Felhasználó törlése',
    }
  },
  messages: {
    createdSuccess: 'Szervezet sikeresen létrehozva',
    createdError: 'Hiba történt a szervezet létrehozása közben',
    updatedSuccess: 'Szervezet sikeresen frissítve',
    updatedError: 'Hiba történt a szervezet frissítése közben',
    deletedSuccess: 'Szervezet sikeresen törölve',
    deletedError: 'Hiba történt a szervezet törlése közben',
    nameRequired: 'Szervezet neve megadása kötelező',
    confirmTitle: 'Szervezet törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt a szervezetet?',
    deleteWarning: 'Ez a művelet nem visszavonható.'
  }
}